import { render, staticRenderFns } from "./highway_project.vue?vue&type=template&id=05e65edc&"
import script from "./highway_project.vue?vue&type=script&lang=js&"
export * from "./highway_project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports